import { render, staticRenderFns } from "./Italist.vue?vue&type=template&id=15f802f9&scoped=true&"
import script from "./Italist.vue?vue&type=script&lang=js&"
export * from "./Italist.vue?vue&type=script&lang=js&"
import style0 from "./Italist.vue?vue&type=style&index=0&id=15f802f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f802f9",
  null
  
)

export default component.exports